module.exports = __webpack_public_path__ + "img/announcement.838e643d.png";